function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_972",
  "data-name": "Group 972"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_971",
  "data-name": "Group 971"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_667",
  "data-name": "Path 667",
  d: "M250.516,46.483a22.742,22.742,0,1,1,22.716-22.767A22.74,22.74,0,0,1,250.516,46.483Zm0-43.451A20.683,20.683,0,1,0,271.2,23.716,20.7,20.7,0,0,0,250.516,3.033Z",
  transform: "translate(-227.8 -1)",
  fill: "#fff"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_974",
  "data-name": "Group 974",
  transform: "translate(13.162 11.943)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_973",
  "data-name": "Group 973"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_668",
  "data-name": "Path 668",
  d: "M273.774,36.8V44.32H269.4V37.306c0-1.779-.61-2.948-2.236-2.948a2.372,2.372,0,0,0-2.236,1.575A3.377,3.377,0,0,0,264.779,37V44.32h-4.32s.051-11.892,0-13.111h4.37v1.88a.05.05,0,0,1-.051.051h.051v-.051a4.277,4.277,0,0,1,3.913-2.185c2.9-.051,5.031,1.829,5.031,5.9ZM253.7,44.32h4.37V31.208H253.7Zm0,0,4.472-17.584a2.236,2.236,0,1,1-2.236-2.236A2.223,2.223,0,0,1,258.172,26.736Z",
  transform: "translate(-253.7 -24.5)",
  fill: "#fff"
})));

var SvgLinkedin = function SvgLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_975",
    "data-name": "Group 975",
    width: 45.432,
    height: 45.483,
    viewBox: "0 0 45.432 45.483",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin.bb7e1dd5.svg";
export { ForwardRef as ReactComponent };